import NavBar from './NavBar';
import PageLoader from './PageLoader';

function Layout() {
  return (
    <>
      <NavBar />
      <PageLoader />
    </>
  );
}

export default Layout;
